import React from "react";
import {Typography} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import {DeviceMetric, DeviceReading} from "../utils/deviceInfo";

// 하루 동안 기록된 측정값 목록 (측정시간 + 측정값)
//
// 최신 기록이 맨 위다. 예전에는 여기서 목록을 뒤집었는데, 넘어오는 기록이 이미
// 최신순이라 뒤집은 결과 맨 위에 그날 가장 오래된 기록이 올라오면서도 '최신' 배지가
// 붙었다(상단 요약의 큰 숫자와도 값이 달랐다). 정렬은 healthDeviceApi 가 보장한다.
const DeviceReadingList = (props: { readings: DeviceReading[], metrics: DeviceMetric[] }) => {
  const readings = props.readings;
  const metrics = props.metrics;

  if (readings.length === 0) {
    return (
      <Typography sx={{ fontSize: 14, color: '#888', textAlign: 'center', p: 2 }}>기록이 없습니다.</Typography>
    );
  }

  return (
    <Box>
      {/* 항목 머리글 */}
      <Stack direction={'row'} alignItems={'center'} sx={{ bgcolor: '#eee', borderRadius: 3, p: '6px 0' }}>
        <Typography component="div" sx={{ ...HeadCellStyle, flex: TIME_FLEX }}>측정시간</Typography>
        {metrics.map((metric) => (
          <Typography key={metric.key} component="div" sx={HeadCellStyle}>
            {metric.label}
            {metric.unit === '' ? null : (
              <Typography component="div" sx={{ fontSize: 11, fontWeight: 400, color: '#888' }}>{metric.unit}</Typography>
            )}
          </Typography>
        ))}
      </Stack>

      {readings.map((reading, index) => {
        const isLatest = index === 0;
        return (
          // 같은 분(HH:mm)에 두 건이 기록되면 시각만으로는 키가 겹친다
          <Box key={`${reading.time}-${index}`}>
            {index > 0 ? <Divider /> : null}
            <Stack direction={'row'} alignItems={'center'} sx={{ py: 1.2 }}>
              <Stack alignItems={'center'} sx={{ flex: TIME_FLEX }}>
                <Typography sx={{ fontSize: 14, fontWeight: isLatest ? 700 : 500, color: isLatest ? '#333' : '#777' }}>
                  {reading.time}
                </Typography>
                {isLatest ? <Typography sx={LatestChipStyle}>최신</Typography> : null}
              </Stack>

              {metrics.map((metric) => (
                <Typography key={metric.key} sx={{ ...ValueCellStyle, color: isLatest ? '#333' : '#999' }}>
                  {reading.values[metric.key] === undefined ? '-' : reading.values[metric.key]}
                </Typography>
              ))}
            </Stack>
          </Box>
        );
      })}
    </Box>
  );
}

// 측정시간 칸은 '최신' 표시가 들어가 조금 넓게 잡음
const TIME_FLEX = 1.2;

const HeadCellStyle = {
  flex: 1, textAlign: 'center', fontSize: 13, fontWeight: 700, color: '#555'
};

const ValueCellStyle = {
  flex: 1, textAlign: 'center', fontSize: 17, fontWeight: 700
};

const LatestChipStyle = {
  mt: .3, fontSize: 10, fontWeight: 700, color: '#EF8322',
  border: '1px solid #EF8322', borderRadius: '8px', p: '0 6px', lineHeight: 1.5
};

export default DeviceReadingList;
